import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import configureStore from './Store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './Config/i18n';
import langService from '../src/Utils/languge';
import ScrollToTop from './Utils/ScrollToTop'
import Splash from './Components/PublicPages/Splash/Splash'
import './Assets/css/custom_toastify_toast.css';
import { ToastContainer } from 'react-toastify';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });


// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            staleTime: Infinity,
        },
    },
})
 
ReactDOM.render(
    <React.Suspense fallback={<Splash />}>
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <ScrollToTop />
                    <App />
                    <ToastContainer style={{ width: "auto", minWidth: "320px" }} />
                    <ReactQueryDevtools initialIsOpen={false} />
                </ConnectedRouter>
            </Provider>
        </QueryClientProvider>
    </React.Suspense>,
    document.getElementById('root'));

langService.loadLangSetup();
registerServiceWorker();
